import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { ApplicantFilterMetaModel } from "./applicant-filter-meta-model";

export class ApplicantReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new ApplicantFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Applicant Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Applicants Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Applicant Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'Score', value: 'Total' }, { key: 'AIR', value: 'AllIndiaRank' }, { key: 'State Rank', value: 'StateRank' }, { key: 'Zone Rank', value: 'ZoneRank' }, { key: '10th', value: 'orgscore10' }, { key: '12th', value: 'orgscore12' }, {key: 'contact', value: 'orgmobile'}] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const scoreTotal = new Headers('Total Score', 'Total', false, false, 'text');

        const air = new Headers('AIR', 'AllIndiaRank', false, false, 'text');
        const stateRank = new Headers('State Rank', 'StateRank', false, false, 'text');
        const ZoneRank = new Headers('Zone Rank', 'ZoneRank', false, false, 'text');
        const score10 = new Headers('10th', 'orgscore10', false, false, 'text');
        const score12 = new Headers('12th', 'orgscore12', false, false, 'text');
        const mobileNumber = new Headers('Contact', 'orgmobile', false, false, 'text');

       
        headers.push(studentName);
        headers.push(scoreTotal);
        headers.push(air);
        headers.push(stateRank);
        headers.push(ZoneRank);
        headers.push(score10);
        headers.push(score12);
        headers.push(mobileNumber);

        return headers;
    }

     override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
      }
}